"use client";

import React, { useState, useRef } from "react";
import styled from "styled-components";
import HoverToolTip from "../Tooltip/HooverTooltip";

const StyledAirlineIcon = styled.img(({ theme }) => ({
  borderRadius: "4px",
  objectFit: "contain",
  backgroundColor: theme.kallisto.color.background.static.backgroundLayer01,
  padding: "2px",
}));

interface AirlineIconProps {
  airlineCode: string;
  airlineName?: string;
  size?: number;
}

const AirlineIcon: React.FC<AirlineIconProps> = ({
  airlineCode,
  airlineName,
  size = 18,
}) => {
  const [isVisible, setIsVisible] = useState(true);
  const [hasError, setHasError] = useState(false);
  const imgRef = useRef<HTMLImageElement>(null);

  const handleError = () => {
    setHasError(true);
    setIsVisible(false);
  };

  const handleLoad = (e: React.SyntheticEvent<HTMLImageElement>) => {
    const img = e.currentTarget;

    // Check if the src has been changed to a data URL (base64 placeholder)
    if (img.src.startsWith("data:image/")) {
      setIsVisible(false);
      return;
    }

    // Additional validation - hide very small images (likely placeholders)
    if (img.naturalWidth < 16 || img.naturalHeight < 16) {
      setIsVisible(false);
      return;
    }
  };

  if (!isVisible || hasError) {
    return null;
  }

  return (
    <HoverToolTip
      content={airlineName || ""}
      trigger={
        <StyledAirlineIcon
          ref={imgRef}
          src={`https://media.staticroot.com/DAM/Commercial%20Partners/Airlines/Icons/${airlineCode}?tr=c-maintain_ratio,w-24,q-70,f-auto`}
          alt={`${airlineName || airlineCode} airline`}
          title={airlineName}
          onError={handleError}
          onLoad={handleLoad}
          style={{ width: `${size}px`, height: `${size}px` }}
        />
      }
    />
  );
};

export default AirlineIcon;
